export const validateMid = (mid: string = '') => {
  const regexString =
    '^CAM-[a-z0-9]{6}\\|TCH-[a-z0-9]{6}\\|TCO-[a-z0-9]{6}\\|CTY-[a-z0-9]{6}\\|CCO-[a-z0-9]{6}\\|PRG-[a-z0-9]{6}$';
  const regex = new RegExp(regexString, 'i');

  return regex.test(mid);
};

/**
 * - mid from URL is always preferred over anything when correctly set.
 * - when mid from URL is not set, the activeMid is used.
 * - when both are not set, the defaultMid is used.
 *
 * @info validation is done before passing mids to this function.
 */
export const getMidByPriority = ({
  activeMid,
  midFromUrl,
  defaultMid,
}: {
  activeMid: string; // can be an empty string as well.
  midFromUrl: string | null;
  defaultMid: string;
}) => {
  return midFromUrl || activeMid || defaultMid;
};
